import CustomAvatarExample from "../../../../../../packages/design-system/avatar/examples/constellation/avatar-custom-content";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHavatar_custom_content from "!!raw-loader!../../../../../../packages/design-system/avatar/examples/constellation/avatar-custom-content";
import * as React from 'react';
export default {
  CustomAvatarExample,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHavatar_custom_content,
  React
};